const btnViewMore = document.querySelector('.collection__view-more button')
!!btnViewMore && btnViewMore.addEventListener('click', () => {
  const description = document.querySelector('.collection_description.rte')
  const textMore = document.querySelector('.moreText')
  description.classList.toggle('expand')
  btnViewMore.classList.toggle('expand')
  btnViewMore.classList.contains('expand') ? (textMore.innerHTML = 'see less') : (textMore.innerHTML = 'view more')
})


const container = document.querySelector('.content-slide-icons')
const toggleModalProduct = [... document.querySelectorAll('.icon-suite a')]
!!toggleModalProduct && toggleModalProduct.map(button => {
  button.addEventListener('click', () => {
    container.classList.add('active')
    const contianerVisually = button.parentElement.querySelector('.visually-hidden')
    const wrapper = container.querySelector('.wrapper-content')
    wrapper.innerHTML = contianerVisually.innerHTML
  })
})

const buttonModalClose = document.querySelector('.icon-close')
!!buttonModalClose && buttonModalClose.addEventListener('click', () => container.classList.remove('active'))

const variants = JSON.parse(document.querySelector('.variants-json').getAttribute('data-variants'))

const availabilityVariants = (select) => {
  clearInterval(searchSelect)

  const options = [... select.options]
  options.map(option => {
    const variant = variants.find(variant => variant.title == option.value || variant.option1 == option.value )
    if(!!variant.available) return

     option.innerHTML = `${variant.title} - Sold Out`
     option.disabled = true
  })
}

const searchSelect = setInterval(() => {
  const findSelect = document.querySelector('select.single-option-selector')
  !!findSelect && availabilityVariants(findSelect)
}, 1000);
